import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import CITargetDaysofSupply from "./CITargetDaysofSupply";
import { setActiveDataElement } from "../../../redux/userSlice";


const CITargetDays = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Concentrate Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection title="Concentrate Inventory Target Days of Supply" />
            <div class="container">
              <CITargetDaysofSupply />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default CITargetDays;
 